import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateService implements CanDeactivate<any> {

    constructor() {
        this.refresh$.subscribe(() => {
            this.canDeactivateList = [];
        });
    }

    private canDeactivateList: boolean[] = [];
    private refresh$ = new Subject();

    registerCanDeactivate(canDeactivateFn: () => boolean, onDestroy: Observable<void>) {
        this.refresh$
            .pipe(takeUntil(onDestroy))
            .subscribe(() => {
                this.canDeactivateList.push(canDeactivateFn())
            });
    }

    canDeactivate(promptUser = true): boolean | Promise<boolean> {
        this.refresh$.next();
        let canDeactivate = this.canDeactivateList.reduce((previousValue, currentValue) => {
            return previousValue && currentValue;
        }, true);
        if (canDeactivate) return true;
        if (promptUser) {
            return this.showWarning();
        }
        return canDeactivate;
    }

    showWarning(): Promise<boolean>{
        return new Promise(resolve => {
            resolve(confirm('You have unsaved changes, would you like to Discard them?'));
        });
    }
}
